/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import { HashRouter } from 'react-router-dom';
import './i18n';
import AppWrapper from './AppWrapper';
import RewardsLayout from './layouts/RewardsLayout';

ReactDOM.render(
  <HashRouter basename="/">
    <RecoilRoot>
      <AppWrapper>
        <RewardsLayout />
      </AppWrapper>
    </RecoilRoot>
  </HashRouter>,
  document.getElementById('app'),
);
